<template>
    <section-container title="Fotos do Veículo" icon="images" :css-class="cssClass">
        <div v-if="hasPhotos" class="vehicle-photos-grid">
            <!-- Foto Frontal -->
            <div v-if="photos.front_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.front_photo" alt="Frontal" class="vehicle-photo" @click="enlargePhoto(photos.front_photo)">
                    <div class="photo-label">
                        <i class="fas fa-car-alt"></i> Frontal
                    </div>
                </div>
            </div>

            <!-- Foto Traseira -->
            <div v-if="photos.back_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.back_photo" alt="Traseira" class="vehicle-photo" @click="enlargePhoto(photos.back_photo)">
                    <div class="photo-label">
                        <i class="fas fa-car-alt fa-flip-horizontal"></i> Traseira
                    </div>
                </div>
            </div>

            <!-- Foto Lateral Esquerda -->
            <div v-if="photos.left_side_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.left_side_photo" alt="Lateral Esquerda" class="vehicle-photo" @click="enlargePhoto(photos.left_side_photo)">
                    <div class="photo-label">
                        <i class="fas fa-car-side"></i> Lateral Esquerda
                    </div>
                </div>
            </div>

            <!-- Foto Lateral Direita -->
            <div v-if="photos.right_side_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.right_side_photo" alt="Lateral Direita" class="vehicle-photo" @click="enlargePhoto(photos.right_side_photo)">
                    <div class="photo-label">
                        <i class="fas fa-car-side fa-flip-horizontal"></i> Lateral Direita
                    </div>
                </div>
            </div>

            <!-- Foto do Teto -->
            <div v-if="photos.ceiling_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.ceiling_photo" alt="Teto" class="vehicle-photo" @click="enlargePhoto(photos.ceiling_photo)">
                    <div class="photo-label">
                        <i class="fas fa-arrow-up"></i> Teto
                    </div>
                </div>
            </div>

            <!-- Foto do Odômetro -->
            <div v-if="photos.odometer_photo" class="photo-item">
                <div class="photo-container">
                    <img :src="photos.odometer_photo" alt="Odômetro" class="vehicle-photo" @click="enlargePhoto(photos.odometer_photo)">
                    <div class="photo-label">
                        <i class="fas fa-tachometer-alt"></i> Odômetro
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="no-photos-message">
            <i class="fas fa-image text-muted"></i>
            <p>Nenhuma foto disponível</p>
        </div>

        <!-- Modal para visualização ampliada da foto -->
        <div v-if="showPhotoModal" class="photo-modal" @click="showPhotoModal = false">
            <div class="photo-modal-content">
                <span class="close-btn" @click.stop="showPhotoModal = false">&times;</span>
                <img :src="currentPhoto" alt="Foto ampliada" class="enlarged-photo">
            </div>
        </div>
    </section-container>
</template>

<script>
import SectionContainer from './SectionContainer.vue';

export default {
    name: "VehiclePhotos",
    components: {
        SectionContainer
    },
    props: {
        photos: {
            type: Object,
            required: true
        },
        cssClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showPhotoModal: false,
            currentPhoto: null
        };
    },
    computed: {
        // Verifica se há pelo menos uma foto para exibir
        hasPhotos() {
            return (
                this.photos.front_photo ||
                this.photos.back_photo ||
                this.photos.left_side_photo ||
                this.photos.right_side_photo ||
                this.photos.ceiling_photo ||
                this.photos.odometer_photo
            );
        }
    },
    methods: {
        // Amplia a foto ao clicar nela
        enlargePhoto(photoUrl) {
            this.currentPhoto = photoUrl;
            this.showPhotoModal = true;
        }
    }
};
</script>

<style scoped>
.vehicle-photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
    margin-top: 15px;
}

.photo-item {
    position: relative;
}

.photo-container {
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    height: 120px;
    transition: transform 0.2s ease;
    cursor: pointer;
}

.photo-container:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.vehicle-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.photo-label {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    color: white;
    padding: 8px 5px 5px;
    font-size: 12px;
    text-align: center;
}

.photo-label i {
    margin-right: 4px;
}

.no-photos-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
}

.no-photos-message i {
    font-size: 48px;
    margin-bottom: 10px;
    opacity: 0.5;
}

.no-photos-message p {
    color: #6c757d;
}

/* Modal de visualização de foto */
.photo-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
}

.photo-modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
}

.close-btn {
    position: absolute;
    top: -40px;
    right: -10px;
    color: white;
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
}

.enlarged-photo {
    max-width: 100%;
    max-height: 90vh;
    border: 2px solid white;
    border-radius: 4px;
}

@media (max-width: 576px) {
    .vehicle-photos-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/VehiclePhotos.vue